import $ from "jquery";
import { CLASSES } from "@/scripts/helpers/constants";
import Cookies from "js-cookie";

export default () => {
  const { IS_VISIBLE } = CLASSES;

  const layout = $(".layout-responsive");

  const cookieName = "COOKIES_DONATE";
  const isCookiesAccepted = Cookies.get(cookieName);

  const popup = $(".donate-ua-banner");
  const close = $(".donate-ua-banner__close");

  const headerTop = $(".page-header--top.page-header--dark-theme");
  const desktopBreakpoint = window.matchMedia("(min-width: 960px)").matches;

  if(headerTop.length && desktopBreakpoint){
    popup.css({ top: "130px" });
  }

  if (popup.length && !isCookiesAccepted) {
    popup.addClass(IS_VISIBLE);
    layout.addClass("donate-banner");
  }

  $(window).on("scroll", function() {
    if (!desktopBreakpoint || !popup.length) return false;

    if (headerTop.length) {
      $(this).scrollTop() >= headerTop.offset().top + headerTop.height()
        ? popup.css({ top: "90px" })
        : popup.css({ top: "130px" });
    }
  });

  close.click(() => {
    Cookies.set(cookieName, "true", { domain: window.location.hostname });
    popup.remove();
    layout.removeClass("donate-banner");
  });

  $(window).scroll(function () {
    const heightBody = $(window).scrollTop(),
          smartBanner = $(".smartbanner-show");

    if (popup.length) {
      const heightBanner = 82;

      if (heightBody > heightBanner) {
        smartBanner.addClass("fixed-donate-banner");
      } else {
        smartBanner.removeClass("fixed-donate-banner");
      }
    }
  });
};
